import { useState } from "react";
import { Space, Divider, Descriptions, Typography, Row, Col, Badge, Button } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import StatementView from "./StatementView";

const { Text, Title } = Typography;

export default function StepReview({ statements, patchStatus, patchStatement }) {
  const [isPatching, setIsPatching] = useState(false);
  console.log('patchStatus', patchStatus);
  const initiatePatching = (toPatch = []) => {
    const toPatchStatements = toPatch?.length > 0 ? toPatch : statements;
    setIsPatching(true);
    const promises = [];
    toPatchStatements.forEach((statement) => {
      promises.push( patchStatement(statement) );
    });

    Promise.all(promises).finally(() => {
      setIsPatching(false);
    });
  }
  
  return (<>
    <Title type="secondary" underline level={3} style={{ textAlign: 'center' }}>
      Review Statements
    </Title>
    {
      statements && statements.map((statement, index) => (
        <Space direction="vertical" style={{ width: '100%' }} key={index}>
          <Row>
            <Col span={20}>
              <StatementView statement={statement} patchStatus={patchStatus[statement.statementId]}/>
            </Col>
            <Col span={4}>
              <Descriptions layout="vertical" bordered column="1" size="small">
                <Descriptions.Item label="Status">
                  <Space direction="vertical">
                    {
                      !patchStatus?.[statement.statementId]?.status
                        && !patchStatus?.[statement.statementId]?.patching
                        && <Text type="secondary"><Badge status="default" /> Ready</Text>
                      }
                    {
                      patchStatus?.[statement.statementId]?.patching
                        && <Text> <Badge status="processing" /> Patching... <LoadingOutlined/></Text>
                      }
                    {
                      patchStatus?.[statement.statementId]?.status
                        && !patchStatus?.[statement.statementId]?.patching
                        && <Text type="success"><Badge status="success" /> Patched!</Text>
                      }
                  </Space>
                </Descriptions.Item>
                {
                  patchStatus?.[statement.statementId]?.errorMsg
                    && <Descriptions.Item label="Error Message">
                    <Text type="error"><Badge status="error" /> {patchStatus?.[statement.statementId]?.errorMsg}</Text>
                    <Button htmlType="button" size="small" onClick={() => initiatePatching([statement])}>Retry</Button>
                  </Descriptions.Item>
                }
              </Descriptions>
            </Col>
          </Row>
          <Divider />
        </Space>
      ))
    }

    {
      statements?.length > 0
      && <Row>
        <Col span="4" offset="20">
          <Button
            onClick={initiatePatching}
            block
            loading={isPatching}
            type="primary"
          >
            {isPatching ? "Patching" : "Patch Selected"}
          </Button>
          </Col>
      </Row>
    }

    {
      statements?.length === 0
      && <h3>No statements selected for patching</h3>
    }
  </>);
}